export default {
  add_items: 'Adaugă produse',
  remove_items: 'Elimină produse',
  place_order: 'Plasează comanda',
  proceed_to_payment: 'Continuă către plată',
  go_to_menu: 'Mergi la meniu',

  toasts: {
    input_errors_found: 'Există probleme cu informațiile comenzii',
  },

  error_messages: {
    internal_error: {
      title: 'Comandă nereușită 😔',
      description:
        'Din păcate, a apărut o problemă neașteptată cu comanda ta, echipa noastră tehnică lucrează deja la rezolvare 🛠️.',
    },
  },
};
